import React, { useEffect, Fragment } from "react";
import { useSelector } from "react-redux";
import Helmet from "react-helmet";
import {
  AboutAuthor,
  AssociatedPublications,
  AssociatedWriters,
  AuthorSubmissions,
  Banner,
  FeaturedPublications,
} from "./components";
import { Typography } from "@material-ui/core";

// const useStyles = makeStyles((theme) => ({
//     banner:{
//         width: '100%',
//         height: '100vh',
//         backgroundImage: `url(${'./assets/images/banner.png'})`,
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center'
//     }
// }))

function Home(props) {
  const state = useSelector((state) => state);
  // useEffect(() => {
  //   console.log({ "Props in Home": state });
  // }, []);
  return (
    <Fragment>
      <Helmet>
        <title>d2p - Decade to Publishing</title>
      </Helmet>

      <Banner />
    </Fragment>
  );
}

export default Home;
